import { Navigate, Outlet, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

type DecodedToken = {
  id: string;
  email: string;
  role: "ADMIN" | "CLIENT" | "FACILITATOR" | "MANAGER" | "EXPERT" | "ECOSYSTEM_HEAD" | "SUB_ADMIN";
  exp: number;
  iat: number;
};

export function FacilitatorProtectedRoute() {
  const location = useLocation();
  const token = Cookies.get("token");

  if (!token) {
    return <Navigate to="/facilitator/login" state={{ from: location }} replace />;
  }

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      Cookies.remove("token");
      return <Navigate to="/facilitator/login" state={{ from: location }} replace />;
    }

    if (decoded.role === "ADMIN" || decoded.role === "SUB_ADMIN") {
      return <Navigate to="/admin/companies" replace />;
    }

    if (decoded.role === "MANAGER") {
      return <Navigate to="/management" replace />;
    }

    if (decoded.role === "CLIENT") {
      return <Navigate to="/dashboard" replace />;
    }

    if (decoded.role === "EXPERT") {
      return <Navigate to="/expert/dashboard" replace />;
    }

    if (decoded.role === "ECOSYSTEM_HEAD") {
      return <Navigate to="/ecosystem-head/dashboard" replace />;
    }

    if (decoded.role !== "FACILITATOR") {
      Cookies.remove("token");
      return <Navigate to="/facilitator/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
  } catch {
    Cookies.remove("token");
    return <Navigate to="/facilitator/login" state={{ from: location }} replace />;
  }
}
